export function initEditControl() {
  const $c = $('.edit-control');
  if ($c && $c.length === 0) return;
  $c.on('click', (e) => {
    $(e.currentTarget)
      .parents('.form-field')
      .find('.form-control')
      .attr('disabled', false);
  });
}
